export const MODULE = "custom-work-order-print-modal/attachments-section";

export const FILE_TYPES = {
  "image/png": "image",
  "image/jpg": "image",
  "image/jpeg": "image",
  "image/heic": "image",
  "application/dwg": "dwg",
  "application/dxf": "dxf",
  "image/vnd.dwg": "dwg",
  "image/vnd.dxf": "dxf",
};

export const getFileType = (fileType) => FILE_TYPES[fileType.toLowerCase()] || "pdf";
